// Utils
import { axios } from 'utils/axios'

/**
 * @description Convert to base 64
 *
 * @param {any} file
 *
 * @return {Promise<any>} Promise<any>
 */
export const fileUtils_convertBase64 = (file: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)

    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

/**
 * @description Convert to base 64 from url
 *
 * @return {string} url
 *
 * @return {Promise<any>} Promise<any>
 */
export const fileUtils_convertUrlToBase64 = async (url: string): Promise<any> => {
  try {
    const data = (await axios.get(url, { responseType: 'blob' })) as any

    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      if (data?.ok) {
        reader.readAsDataURL(data?.res)

        reader.onloadend = () => {
          const base64data = reader.result
          resolve(base64data)
        }

        reader.onerror = () => {
          reject()
        }
      } else {
        reject()
      }
    })
  } catch (err) {
    return Promise.reject()
  }
}

/**
 * @description Extract base64
 *
 * @param {string} image
 *
 * @return {Promise<any>} Promise<any>
 */
export const fileUtils_extractBase64 = async (image: string): Promise<any> => {
  if (image) {
    try {
      const base64 = image?.split(',')?.[1] || ''
      // const base64FromUrl = !base64 ? await fileUtils_convertUrlToBase64(image) : ''
      // const extractedBase64 = base64 ? base64 : base64FromUrl?.split(',')?.[1] || ''

      return Promise.resolve(base64)
    } catch (_) {
      return Promise.reject()
    }
  } else {
    return ''
  }
}

/**
 * @description Get dimensions from image
 *
 * @return {File} file
 *
 * @return {Promise<{width: number, height: number} | void>} Promise<{width: number, height: number} | void>
 */
export const fileUtils_getDimensions = async (file: File): Promise<{ width: number; height: number } | string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)

    reader.onload = () => {
      let img = new Image()

      img.onload = function () {
        let { width, height } = img

        resolve({ width, height })
      }

      img.src = reader.result as any
    }

    reader.onerror = () => {
      reject('app.validations.files.checkFailed')
    }
  })
}
